import {
  Banner,
  Fade,
  Typography,
  useNavigate,
  useLocation,
} from '@forgeglobal/design-framework';
import DialogBody from '@tcs/client-portal-common/components/organisms/DialogLayout/DialogBody';
import DialogPageLayout from '@tcs/client-portal-common/components/organisms/DialogLayout/DialogPageLayout';
import { useStyles } from './style';
import { useTokenSetPasswordMutation } from '@tcs/client-portal-common/hooks/auth';
import EnterNewPasswordForm from './EnterNewPasswordForm';
import { useState } from 'react';

export const EnterNewPassword = () => {
  const nav = useNavigate();
  const location = useLocation();
  const classes = useStyles();
  const setPasswordWithToken = useTokenSetPasswordMutation();
  const [showErrorBanner, setShowErrorBanner] = useState(false);
  const [errorBannerMessage, setErrorBannerMessage] = useState('');

  const urlSearchParams = new URLSearchParams(location.search);
  const recoveryToken = urlSearchParams.get('recovery_token');
  const onSubmit = (values) => {
    const { newPassword } = values;

    setPasswordWithToken
      .mutateAsync({
        password: newPassword,
        recoveryToken,
      })
      .then(() => {
        nav('/login?showChangePasswordBanner=true');
      })
      .catch((e) => {
        if (e.response.status === 400) {
          if (e.response.data === 'Password cannot be your current password') {
            setErrorBannerMessage(
              'Password must not match the previous 5 passwords'
            );
          } else {
            setErrorBannerMessage(e.response.data);
          }
        }
        setShowErrorBanner(true);
      });
  };
  const onBackToSignIn = () => {
    nav('/login');
  };
  const onCancel = () => {
    window.location.href = 'https://app.forgetrust.com/client-portal/';
  };

  return (
    <DialogPageLayout showCloseArrow={false}>
      {showErrorBanner && (
        <div className={classes.errorBanner}>
          <Fade in={showErrorBanner} timeout={750}>
            <div>
              <Banner severity="error">
                <Typography
                  variant="body2"
                  color="textPrimary"
                  data-test-id="login-message">
                  Password change was unsuccessful. {errorBannerMessage}
                </Typography>
              </Banner>
            </div>
          </Fade>
        </div>
      )}
      <DialogBody type={'form'}>
        <Typography
          className={classes.title}
          variant="h5"
          data-test-id="sub-title">
          Reset Password
        </Typography>
        <EnterNewPasswordForm
          onSubmit={onSubmit}
          onCancel={onCancel}
          onBackToSignIn={onBackToSignIn}
        />
      </DialogBody>
    </DialogPageLayout>
  );
};
